import { render } from "./ModalCreateFile.vue?vue&type=template&id=4d5082f4&scoped=true"
import script from "./ModalCreateFile.vue?vue&type=script&lang=js"
export * from "./ModalCreateFile.vue?vue&type=script&lang=js"

import "./ModalCreateFile.vue?vue&type=style&index=0&id=4d5082f4&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5082f4"]])

export default __exports__